import type { PageModuleConfig } from '@openreply/loader-remote-module-config-vite-plugin';

const configuration: PageModuleConfig = {
  includeType: 'page',
  module: 'consent-management',
  customElement: 'hobi-consent-management',
  pages: [], // to be available on all pages
};

export default configuration;
